
import { Component, Vue } from "vue-property-decorator";
import { customerService } from "@/services/api/customers.service";
import { getModule } from "vuex-module-decorators";
import store from "@/store";
import AuthModule from "@/store/modules/core/auth.module";
const authModule = getModule(AuthModule, store);
const AppBar = () => import("@/components/core/AppBar.vue");
const AppFooter = () => import("@/components/core/AppFooter.vue");
const MessageDialog = () => import("@/components/core/MessageDialog.vue");

@Component({
  components: {
    AppBar,
    AppFooter,
    MessageDialog,
  },
})
export default class Password extends Vue {
  // VARS
  private dialogEdit = false;
  private valid = true;
  private isLoading = false;
  private isLoadingButton = false;
  private search = "";
  private catalogs = ["MAK", "FERRO", "GMP"];
  private headers =
    this.getRole == "0"
      ? [
          {
            text: "Codice",
            align: "start",
            filterable: true,
            value: "codiceCliente",
          },
          { text: "Password", value: "taxID" },
          { text: "Ragione Sociale", value: "ragioneSociale" },
          { text: "Email", value: "email" },
          { text: "Abilitato", value: "isEnabled" },
          { text: "Ordini completati", value: "numCompletedOrder" },
          { text: "Percentuale", value: "percentOrderCompleted" },
          { text: "", value: "actions" },
        ]
      : [
          {
            text: "Codice",
            align: "start",
            filterable: true,
            value: "codiceCliente",
          },
          { text: "Password", value: "taxID" },
          { text: "Ragione Sociale", value: "ragioneSociale" },
          { text: "Email", value: "email" },
          { text: "Abilitato", value: "isEnabled" },
          { text: "", value: "actions" },
        ];
  private set = [];
  private editItem = {
    email: "",
    taxID: "",
    codiceCliente: "",
    isEnabled: true,
  };
  // VARS --- COMPONENTS
  private numberSelected = 0;
  private messageDialogOpen = false;
  private dialogText = "";

  // RULES:
  private nonEmptyRule = [(v) => !!v || "Questo campo non può essere vuoto!"];
  private sixElements = [
    (v) => /^[a-zA-Z0-9]{6,6}$/.test(v) || "Servono sei caratteri",
  ];

  get getRole(): string {
    return authModule.role;
  }

  // MOUNTED
  mounted(): void {
    this.printTable();
  }

  // METHODS --- LOAD CUSTOMER TABLE
  private printTable(): void {
    this.isLoading = true;
    customerService.getCustomers("", "").then((res) => {
      this.set = res.data;
      this.isLoading = false;
    });
  }

  // METHODS --- RETURN FRACTION OF COMPLETED ORDERS
  private showFraction(ordersCompleted, ordersNotCompleted): string {
    return `${ordersCompleted}/${ordersCompleted + ordersNotCompleted}`;
  }

  // METHODS --- OPEN EDIT MODAL
  private toggleEdit(item): void {
    // Set new item
    Object.keys(item).forEach((key) => {
      this.editItem[key] = item[key];
    });
    // Set dialog & open
    this.dialogEdit = true;
  }

  // METHODS --- GET CUSTOMERS
  private saveEdit(): void {
    this.isLoadingButton = true;
    // Send item to server
    let itemToSend = {
      Email: this.editItem.email,
      CodiceCliente: this.editItem.codiceCliente,
      TaxID: this.editItem.taxID,
      IsEnabled: this.editItem.isEnabled,
    };
    customerService
      .updateCustomer(itemToSend)
      .then((res) => {
        // Reprint table & close edit dialog
        this.dialogEdit = false;
        this.printTable();
        // Open state dialog
        if (res.status === 200) {
          this.dialogText = "Dati dell'utente modificati correttamente!";
          this.messageDialogOpen = true;
          this.isLoadingButton = false;
        } else {
          errorHandling();
        }
      })
      .catch((e) => {
        console.warn(e);
        errorHandling();
      });

    let errorHandling = (): void => {
      this.dialogText = "Non è stato possibile modificare i dati dell'utente!";
      this.messageDialogOpen = true;
      this.isLoadingButton = false;
    };
  }
}
